<template>
  <v-select
    v-model="item"
    dir="rtl"
    :multiple="multiple"
    :clearable="clearable"
    :options="items"
    :loading="loading"
    :selectable="x => unselectable.includes(x[valueItem]) === false || x === val"
    :label="label"
    :reduce="x => x[valueItem]"
    @open="onOpen"
    @option:selected="$emit('selected')"
  >
    <span
      slot="no-options"
      @click="$refs.select.open = false"
    >
      {{ $t('common.noOptions') }}
    </span>
    <template #spinner>
      <div class="demo-inline-spacing">
        <b-spinner
          v-if="loading"
          class="m-0"
          small
          variant="secondary"
        />
      </div>
    </template>
  </v-select>
</template>

<script>

import { mapState } from 'vuex'

export default {
  name: 'ZDynamicSelect',
  props: {
    value: {
      type: [String, Number, Array],
      default: null,
    },
    url: {
      type: String,
      default: null,
    },
    method: {
      type: String,
      default: 'get',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    unselectable: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: 'Name',
    },
    valueItem: {
      type: String,
      default: 'Id',
    },
  },
  data() {
    return {
      selected: null,
      val: this.value,
      loading: false,
    }
  },
  watch: {
    value(v) {
      this.val = v
    },
  },
  computed: {
    ...mapState('zirehState', { items: state => state.dynamicSelect }),
    ...mapState('zirehState', { flag: state => state.dynamicSelectFlag }),
    item: {
      get() {
        if (this.value && (this.value.length || this.multiple === false)) {
          this.get()
        }
        return this.val
      },
      set(newValue) {
        this.$emit('input', newValue)
        this.val = newValue
      },
    },
  },
  methods: {
    get() {
      if (!this.url) return
      if (this.flag === false && this.items.length === 0) {
        this.$store.commit('zirehState/setDynamicSelectFlag', true)
        this.loading = true
        this.$http[this.method](this.url)
          .then(res => {
            let data = res.data
            let items = data.map(item => ({
              key:item,
              value:item
            }))
            this.$store.commit('zirehState/setDynamicSelect', items)
            this.loading = false
          }).catch(() => {
          this.loading = false
        })
      }
    },
    onOpen() {
      this.get()
    },
  },
}
</script>
